/**
 * Asynchronously loads the component
 */
import Loadable from 'react-loadable';

import LoadingIndicator, { SwiperLoading, NumericalLoading } from 'ui/LoadingIndicator';

export const SPINNER = 'spinner_loading';
export const SWIPER = 'swiper_loading';
export const NUMERICAL = 'numerical_placeholder';

const getLoadingIndicator = (type) => {
  switch (type) {
    case SWIPER:
      return SwiperLoading;
    case NUMERICAL:
      return NumericalLoading;
    case SPINNER:
    default:
      return LoadingIndicator;
  }
};

export default ({ ...opts }, indicatorType = SPINNER) => {
  return Loadable({
    loading: getLoadingIndicator(indicatorType),
    ...opts,
  });
};
